import React from 'react'
import { Outlet } from 'react-router-dom'

function MainCollectionAndReturn() {
 return (
    <div>
      <Outlet/>
    </div>
  )
}

export default MainCollectionAndReturn